module.exports = new __parcel__URL__("project-issue-navigator-nav4-skeleton.tpl.0c4c4250.svg").toString();